<template>
  <DataTable
    expandable
    :cols="cols"
    :data="items"
  >
    <template v-slot:item.expander="{ item }">
      <div class="ml-7 pa-2">
        <v-row
          dense
          no-gutters
          v-if="item.message"
        >
          <v-col class="mb-2" style="white-space:pre-wrap">
            <v-sheet
              rounded
              color="white"
              class="d-flex align-center pa-4"
            >
              {{ item.message }}
            </v-sheet>
          </v-col>
        </v-row>
        <v-row
          dense
          no-gutters
          class="d-flex my-1"
        >
          <v-col
            v-for="(file, i) in item.uploads"
            cols="auto"
            class="mr-3 mb-2"
            :key="i"
          >
            <v-btn
              class="text-none pa-5 pr-4 pl-3"
              depressed
              color="primary lighten-1"
              outlined
              @click="$emit('view', { item, index: i })"
            >
              <v-icon class="mr-2">
                {{ mdiBookOutline }}
              </v-icon>
              <div class="primary--text">{{ file.acbFindingFile }}</div>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </template>
  </DataTable>
</template>

<style scoped>
.v-btn {
  background-color: white !important;
}
</style>

<script>
import { mdiBookOutline } from "@mdi/js"

export default {
  props: {
    items: {
      type: Array,
      default() { return {} }
    }
  },
  data () {
    return {
      cols: [
        {
          field: 'subject',
          label: 'Subject',
          width: '30%'
        },
        {
          field: 'uploads',
          label: 'Findings',
          width: '5%',
          valueFunction: item => {
            return `${item.uploads.length} file${item.uploads.length - 1 ? 's' : ''}`
          }
        },
        {
          field: 'uploads',
          label: '',
          width: '55%',
          truncate: true,
          valueFunction: item => {
            return `${item.uploads[0] ? item.uploads[0].acbFindingFile : ''}`
          }
        },
        {
          field: 'uploaded',
          label: 'Uploaded',
          width: '10%',
          valueFunction: item => {
            return new Date(item.metadata.uploaded.date).toIACSformatLocal()
          }
        }
      ],
      mdiBookOutline
    }
  },
}
</script>
